<template>
  <BQdtCard
    name="paymHelp"
    type="help"
  />
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'PaymentsHelp',

  components: { BQdtCard },
}
</script>
